import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getRbacPermissions } from "../../../services/rbacService";
import { AUTH_REDUCER } from "../../../constants/enums";
import { useDispatch, useSelector } from "react-redux";
import { checkSubscriptionPermission } from "../../../helper";
import { Console } from "console";

const RbacRoute = (props: any) => {
  const { allowedPermissions, component, requiredPlansPermission } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );

  const hasPermission = () => {
    return allowedPermissions.every((permission: any) =>
      permissions?.includes(permission)
    );
  };

  useEffect(() => {
    if (
      (plansPermissions?.length &&
        !checkSubscriptionPermission(
          requiredPlansPermission,
          plansPermissions,
          -1
        )) ||
      (permissions?.length && !hasPermission())
    ) {
      navigate("/dashboard");
    }
  }, [permissions, plansPermissions]);

  return component;
};
export default RbacRoute;
